import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LandingPage from '../pages/LandingPage';

const Home = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#0d0f14', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', padding: '40px', color: '#fff' }}>
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  // Authenticated users go to profile, guests see the landing page
  if (isAuthenticated) {
    return <Navigate to="/profile" replace />;
  }

  return <LandingPage />;
};

export default Home;